<textarea
  autosize
  class="textarea"
  placeholder="Ask me a question"
  hfSendOnEnter
  (hfSendOnEnter)="sendQuestion()"
  aria-label="Message to AI. Press Enter to send. Shift+Enter adds a new line."
  [formControl]="chatbotUserResponseFormGroup.get('question')"
></textarea>
<button
  class="square-btn primary-new"
  aria-label="Send message"
  [disabled]="chatbotStreaming$ | async"
  (click)="sendQuestion()"
>
  <img src="/assets/icons/chatbot/send-icon.svg" alt="Send chatbot message" />
</button>
